// CANONICAL COPY (GH #7115). src/constants/obligations/obl-isms-resources.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-isms-resources',
  title: 'Verify ISMS resources are allocated',
  description:
    'Confirm that top management has determined and provided the resources (people, budget, tooling) needed to establish, implement, maintain and continually improve the ISMS. Evidence includes approved resource plans and management review minutes.',
  category: 'governance',
  scfIds: ['SCF-MSS-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'ISMS resource plan or statement is published' },
    { type: 'document-approved', description: 'Resource plan has been approved by management' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
